/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React, { useState, useEffect } from "react";

import ItemContainer from "./ItemContainer";
import EditItemPane from "./EditItemPane";


export default function EditItem(props) {
  return (
    <ItemContainer>
      <EditItemPane itemAction='updateItem' />
    </ItemContainer>
  );
}


